import React, { Fragment } from "react";
import _ from "lodash";
import styled from "styled-components";
import moment from "moment";
import { connect } from "formik";
import { Grid } from "@material-ui/core";
import { TextInput, DatePicker } from "components/Global/FastFormikMaterial";

import ViewOnlyDiv from "./ViewOnlyDiv";
import LateralField from "./LateralField";

const StyleDatePicker = styled(DatePicker)`
  && {
    width:100%;
  }
`;
const SideLabelDateInputWithRefInput = ({ label, fieldName, placeholder, formik, isDisabled, shouldHideForQuote, isIndented, hasBorder, isShort, ...otherProps }) => {
  if (shouldHideForQuote) {
    return null;
  }

  const { values } = formik;
  const val = _.get(values, fieldName);
  const refVal = _.get(formik.values, `${fieldName}Ref`);

  return (
    <LateralField label={label} hasBorder={hasBorder}>
      {isDisabled && (
        <Grid container item spacing={16}>
          <Grid item xs={10}>
            <ViewOnlyDiv style={{ borderBottom: `${hasBorder && Boolean(isShort) ? "1px solid gainsboro" : ""}`, paddingRight: "20px" }}>
              {val ? moment(val).format("MM/DD/YYYY") : "--"}
            </ViewOnlyDiv>
          </Grid>
          <Grid item xs={2}>
            <ViewOnlyDiv placeholder="No reference">{refVal}</ViewOnlyDiv>
          </Grid>
        </Grid>)}
      {!isDisabled && (
        <Grid container item spacing={16}>
          <Grid item xs={9}>
            <StyleDatePicker
              style={{ borderBottom: `${hasBorder && Boolean(isShort) ? "1px solid gainsboro" : ""}`, paddingRight: "20px" }}
              fieldName={fieldName}
              placeholder={placeholder}
              {...otherProps}
            />
          </Grid>
          <Grid item xs={3}>
            <TextInput
              fullWidth
              fieldName={`${fieldName}Ref`}
              placeholder="Add a reference"
              {...otherProps}
            />
          </Grid>
        </Grid>)}
    </LateralField>
  );
};
export default connect(SideLabelDateInputWithRefInput);
